import { createContext } from 'react'
import type { AdminCredentials } from './adminCreds'

export type AdminState =
  | { status: 'loading' }
  | { status: 'not-admin' }
  | { status: 'admin'; credentials: AdminCredentials }

export interface AdminContextValue {
  state: AdminState
  refresh: () => Promise<void>
}

export const AdminContext = createContext<AdminContextValue | null>(null)
